"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ToggleSwitchV = require("../ToggleSwitchV2");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ToggleSwitchComponent = function ToggleSwitchComponent(_ref) {
  var filterHidden = _ref.filterHidden,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(_ToggleSwitchV.ToggleSwitchV2, {
    toolTipMessage: "Do not show hidden sources in the source area.",
    label: "Filter hidden sources",
    checked: filterHidden
    // Explicitly setting this to 'true' since it does NOT require permission for now
    ,
    enableFeature: true,
    labelCursor: "text",
    onClick: onClick,
    ddActionName: filterHidden ? 'Disable hidden sources' : 'Enable hidden sources'
  });
};
var SourceListFilter = function SourceListFilter(_ref2) {
  var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(_ref2), _ref2));
  return /*#__PURE__*/_react["default"].createElement(ToggleSwitchComponent, props);
};
var SourceListFilterPropTypes = {
  onClick: _propTypes.func,
  filterHidden: _propTypes.bool
};
ToggleSwitchComponent.propTypes = SourceListFilterPropTypes;
SourceListFilter.propTypes = SourceListFilterPropTypes;
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SourceListFilter);